import React from "react";

function vehicleNotAffected() {
  return (
    <div className="col-md-8 col-md-offset-2 takataRecall ">
      <div className="carDetails">
        <div className="carDetails__wrap">
          <h2 className="carDetails__heading h5">No recalls found</h2>
          <p className="carDetails__statusMessage">
            The Subaru VIN/registration number you entered is <strong>not</strong> subject to any recalls.
          </p>
          <p>
            If you have any questions relating to Subaru Australia initiated recalls, please contact our dedicated
            Recall Contact Centre on <strong>1300 550 994</strong> or email
            <a href="mailto:feedback@subaru.com.au">feedback@subaru.com.au</a>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default vehicleNotAffected;
